import { isIE, isSafari } from 'react-device-detect';

export function scrollElementIntoView(element, block = 'start') {
    element.scrollIntoView(isIE || isSafari ? true : { behavior: 'smooth', block });
}
